<app-navbar></app-navbar>

<div class="container-fluid course-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar course-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 course-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>FEA - Electric Charger Installation</h1>
        <p class="course-subtitle">Learn through guided lessons and complete the module resources and progress checkpoints.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Electric Charger Installation</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FCharger-Installation-Erica-Dakwa%2FErica%20(Electric%20Charger%20Installation).mp4?alt=media&token=71f2b200-4184-487c-b913-2c3d39500ea5" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> How Charging Stations Are Powered</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FCharger-Installation-Erica-Dakwa%2FErica%20(How%20Charging%20Stations%20Are%20Powered).mp4?alt=media&token=6724e225-6ae6-4d2e-9ddc-0712693fee97" type="video/mp4">
          </video>
        </article>

      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FCharger-Installation-Erica-Dakwa%2FCHARGER%20INSTALLATION%20-%20SOLAR%20INSTALLATION%20FINAL.pptx?alt=media&token=02ce86ef-be5e-4637-bee1-82ac540c2324" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <p class="action-note">Assessment is after watching Solar Installation Videos</p>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
